<p [innerHtml]="text" style="display: inline;"></p>
<ng-container *ngIf="!isLast">
  <span *ngIf="!mobileMode" style="white-space: nowrap"> {{lastWord}}<input class="input" [(ngModel)]="currentValue"
      (input)="onInputChange(answer.value)" (focus)="focusInput()" #answer="ngModel"></span>
  <!-- Mobile input doesn't trigger soft keyboard -->
  <span *ngIf="mobileMode" style="white-space: nowrap; line-height: 1rem;"> {{lastWord}}<span class="input-mobile"
      [ngClass]="{'active-input': isActiveInput(), 'input-empty': !currentValue}" (click)="focusInput()">
      <gast-cloze-test-exercise-input-field [inputText]="currentValue" [inputNumber]="nr" [answer]="answer">
      </gast-cloze-test-exercise-input-field>
    </span>
  </span>
</ng-container>
